module.exports = __webpack_public_path__ + "assets/img/看行情，不卡顿.4505de1d.jpg";